export const SET_USERINFO = 'SET_USERINFO'
export const SET_PERMISSION = 'SET_PERMISSION'
export const SET_ACCOUNT = 'SET_ACCOUNT'
export const SET_ORGINFO = 'SET_ORGINFO'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_SESSIONKEY = 'SET_SESSIONKEY'
export const SET_B2BDEFSUPPID = 'SET_B2BDEFSUPPID'
export const SET_SHPINFO = 'SET_SHPINFO'
export const SET_CARTCOUNT = 'SET_CARTCOUNT'
export const SET_CURPAGE = 'SET_CURPAGE'
export const SET_GODTYPELIST = 'SET_GODTYPELIST'
export const SET_NAVIBARITEMLIST = 'SET_NAVIBARITEMLIST'
export const SET_SHPSEARCHBAR = 'SET_SHPSEARCHBAR'
export const SET_CARTLIST = 'SET_CARTLIST'
export const SET_TRDACTIVITYS = 'SET_TRDACTIVITYS'
